import React, { memo, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { plainText_nativeIssueTable_PlainTextCell$key } from '@atlassian/jira-relay/src/__generated__/plainText_nativeIssueTable_PlainTextCell.graphql';
import { TruncatedTextWithPopup } from '../../truncated-text-cell-with-popup';

export type Props = {
	fieldRef: plainText_nativeIssueTable_PlainTextCell$key;
	/**
	 * Should only be needed For VR testing, to render a storybook example with
	 * the popup content immediately visible
	 */
	shouldOpenOnFirstRender?: boolean;
};

export const PlainTextCell = memo<Props>(({ fieldRef, shouldOpenOnFirstRender = false }: Props) => {
	const { text } = useFragment<plainText_nativeIssueTable_PlainTextCell$key>(
		graphql`
			fragment plainText_nativeIssueTable_PlainTextCell on JiraSingleLineTextField {
				text
			}
		`,
		fieldRef,
	);
	const [isOpen, setIsOpen] = useState(shouldOpenOnFirstRender);
	return (
		<TruncatedTextWithPopup
			isOpen={isOpen}
			onSetIsOpen={setIsOpen}
			content={<p>{text}</p>}
			triggerText={text ?? null}
		/>
	);
});
